module.exports = __webpack_public_path__ + "img/fitlab-logo.e112b6d8.svg";